export default class EventGrid extends HTMLElement {
    constructor() {
        super();
    }
}

window.customElements.define('nc-event-grid', EventGrid);
